
import { Card, Col, Row } from "react-bootstrap";
import { StyledCardBodyOverflow, StyledCardHeader } from "../../../components/dashboard/attentionPoints/styles";
import DashboardChart from "../../../components/dashboard/chart";
import { useTranslation } from 'react-i18next';

interface IfozEvolutionChartProps {
    generalData: any[];
    filteredData: any[];
}

/**
 * Component to display the IBFOZ evolution chart.
 */
const IfozEvolutionChart = ({ generalData, filteredData }: IfozEvolutionChartProps) => {
    const { t } = useTranslation('insights');
    return (
        <Row className='pb-2 pt-2 '>
            <Col>
                <StyledCardBodyOverflow style={{ background: '#FFF', color: '#3C4043', overflowX: 'auto', overflowY: 'hidden' }}>
                    <StyledCardHeader>
                        <h5 className='pb-0'>{t('evolutionTitle')}</h5>
                    </StyledCardHeader>
                    <Card.Body>
                        <div style={{ overflow: 'auto', minWidth: '950px', overflowY: 'hidden' }}>
                            <DashboardChart 
                                isLargeChart={true} 
                                positionLine='7%' 
                                lineSize='335px' 
                                height={400} 
                                generalData={generalData} 
                                filteredData={filteredData} 
                                typeKey={1} 
                            />
                        </div>
                    </Card.Body>
                </StyledCardBodyOverflow>
            </Col>
        </Row>
    );
};

export default IfozEvolutionChart;
